<template>
    <div class="all">
        <el-row type="flex" class="row-bg">
            <el-col :span="1"><div></div></el-col>
            <el-col :span="4" class="el-head">
                <div class="headleft">
                    <img
                        src="../../../admin/assets/images/logo.png"
                        class="headlefticon"
                    />
                </div>
            </el-col>
            <el-col :span="14">
                <div class="mid">
                    <el-menu
                        :default-active="curActive"
                        class="el-menu-demo"
                        mode="horizontal"
                        background-color="#2167F3"
                        text-color="#FFFFFF"
                        :router="true"
                        active-text-color="#FFFFFF"
                    >
                        <el-menu-item index="/">首页</el-menu-item>
                        <el-submenu
                            index="2"
                            :default-active="curActive"
                            class="navbar"
                            mode="horizontal"
                            :router="true"
                        >
                            <template slot="title">培训课程</template>

                            <div v-for="item in list" :key="item.id">
                                <el-menu-item
                                    :index="'/' + item.url + '/' + item.id"
                                    >{{ item.title }}</el-menu-item
                                >
                            </div>
                            <!-- <el-menu-item index="/safety"
                                >反诈安全员</el-menu-item
                            > -->
                            <!-- <el-menu-item index="/sub">培训课程</el-menu-item> -->
                        </el-submenu>
                        <el-menu-item index="/guide">报考指南</el-menu-item>
                        <el-submenu
                            index="3"
                            :default-active="curActive"
                            class="navbar"
                            mode="horizontal"
                            :router="true"
                        >
                            <template slot="title">在线评测</template>
                            <!-- <el-menu-item index="/simulation">模拟练习</el-menu-item> -->
                            <el-menu-item index="/examination"
                                >参加考试</el-menu-item
                            >
                        </el-submenu>
                        <el-submenu index="4">
                            <template slot="title">证书发放</template>
                            <!-- <el-menu-item index="/certsearch">证书查询</el-menu-item> -->
                            <el-menu-item index="/certinfo"
                                >证书介绍</el-menu-item
                            >
                        </el-submenu>
                        <el-menu-item index="/people">素材中心</el-menu-item>
                    </el-menu>
                </div>
            </el-col>
            <el-col :span="4">
                <div v-if="login" class="headright">
                    <span class="user"
                        ><i class="el-icon-user"></i> {{ user.name }}</span
                    >
                    <span
                        @click="link('UserInfo', 'info')"
                        style="color: #409eff"
                        class="usercenter"
                        >个人中心 <i class="el-icon-arrow-right"></i
                    ></span>
                </div>
                <div class="headright" v-else>
                    <div class="right" @click="link('Login')">登录</div>
                    <button class="reg" @click="link('Regist')">
                        立 即 注 册
                    </button>
                </div>
            </el-col>
            <el-col :span="1"><div></div></el-col>
        </el-row>
        <div class="main">
            <router-view></router-view>
        </div>
        <div class="footer">
            <span>版权所有：上海黑瞳教育科技有限公司</span>
            <span>地址：上海市浦东新区川和路55弄</span>
            <span>邮编：200120</span>
            <a href="https://beian.miit.gov.cn"
                >备案号：沪ICP备2023014565号-1</a
            >
        </div>
    </div>
</template>

<script>
import ImportData from "../../../admin/components/importData.vue";

export default {
    name: "Layout",
    components: { ImportData },
    data() {
        return {
            curActive: "/",
            user: {},
            login: false,
            list: []
        };
    },
    mounted() {
        this.curActive = this.$route.path;
    },
    created() {
        this.init();
    },
    watch: {
        $route(to) {
            if (to.path == "/") {
                this.init();
            }
        }
    },
    methods: {
        init() {
            this.user = this.$store.state.wps_user || null;
            this.login = this.$store.state.wps_user.mobile ? true : false;
            let _this = this;
            _this.$http
                .post(process.env.VUE_APP_URL + "article/navClist")
                .then(data => {
                    if (data.data.code == 200) {
                        this.list = data.data.data;
                        this.list.forEach((item, i) => {
                            if (i == 0) {
                                item.url = "news";
                            }
                            if (i == 1) {
                                item.url = "safety";
                            }
                            if (i == 2) {
                                item.url = "train";
                            }
                        });
                        return;
                    }
                    {
                        _this.$message.error(data.data.msg);
                        return;
                    }
                })
                .catch(function(error) {
                    _this.$message.error("网络错误，请刷新界面重试");
                    return;
                });
        },
        link(name, id) {
            if (id) {
                this.$router.push({ name: name, params: { id: id } });
            } else {
                this.$router.push({ name: name });
            }
        },
        toHome() {
            this.$router.push({ path: "/" });
        }
    }
};
</script>
<style lang="less" scoped>
.all {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
}
.row-bg {
    background-color: #2167f3;
    width: 100%;
    border-bottom: 1px solid #609bff;
}
.el-head {
    display: flex;
    justify-content: center;
    align-items: center;
}
.headleft {
    width: 200px;
}
.headlefticon {
    height: 29px;
}
.el-menu-item {
    padding: 0 17px;
}

.mid {
    height: 60px;
    display: flex;
    justify-content: center;
}
.eye {
    width: 30px;
    height: 30px;
}
.headright {
    height: 60px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
.headright span {
    cursor: pointer;
}
.right {
    height: 30px;
    margin-right: 20px;
    color: #ffffff;
    font-size: 16px;
    line-height: 30px;
}
.reg {
    color: #2167f3;
    width: 100px;
    height: 25px;
    border: #ffffff;
    font-size: 15px;
}
.footer {
    width: 100%;
    height: 60px;
    background-color: #02203a;
    text-align: center;
    line-height: 60px;
    color: #4582b1;
}
.footer a {
    color: #4582b1;
}
.footer span {
    margin-right: 25px;
}
.fixed {
    position: fixed;
    width: 100%;
    // height: auto;
    background: #fff;
    overflow-y: auto;
    top: 0;
    z-index: 1024;
    box-shadow: 0 0 8px #e7e7e7;
}
.logo {
    width: 335px;
    height: 61px;
}
@media screen and (max-width: 768px) {
    .el-menu-item {
        padding: 0 8px;
    }
    /deep/.el-submenu__title {
        padding: 0 5px;
        background-color: #2167f3;
        // border-bottom-color:#FFFFFF;
        // color:#FFFFFF;
        font-weight: 500;
    }
    .user {
        color: #fff;
        font-size: 8px;
        margin-right: 10px;
        cursor: pointer;
    }
    .usercenter {
        font-size: 10px;
        cursor: pointer;
    }
    .headleft {
        width: 150px;
    }
    .headlefticon {
        height: 20px;
    }
}
</style>
<style>
.el-tooltip__popper.is-light {
    box-shadow: none !important;
    /* max-width: 250px; */
}
.tooltips p {
    text-align: left;
    margin-top: 6px;
    padding-left: 40px;
    text-indent: -37px;
}
.tooltips h4 {
    font-size: 16px;
    margin-bottom: 12px;
    text-align: center;
}
.user {
    color: #fff;
    font-size: 15px;
    margin-right: 15px;
}
</style>
